import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { mapApiEventsResponse } from '../components/Events/mapApiEventToListItem';
import { EVENTS_SCOPE, useEventsScope } from '../contexts/EventsScopeContext';

export const useEventsListQuery = (params, options = {}) => {
  const { enabled = true } = options;
  const { api, queryKeys, scope } = useEventsScope();

  return useQuery({
    queryKey: queryKeys.list(params),
    enabled,
    queryFn: async () => {
      const result = await api.getEvents(params);

      if (!result.success) {
        throw new Error(result.message || 'Failed to load events');
      }

      return mapApiEventsResponse(result.data, {
        partnerList: scope === EVENTS_SCOPE.PARTNER,
      });
    },
    placeholderData: keepPreviousData,
  });
};
